import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=f5c25268&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=f5c25268&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c25268",
  null
  
)

export default component.exports